import { useTranslation } from 'react-i18next';
import { ClipboardList } from 'lucide-react';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Item,
  ItemContent,
  ItemTitle,
  ItemActions,
  ItemGroup,
  Switch
} from '@bliks-io/ui';

interface SurveySettingsCardProps {
  enableRatingAndComment: boolean;
  enableFrequencyMeasurement: boolean;
  enableDurationMeasurement: boolean;
  enableVariantCheck: boolean;
  onToggleRatingAndComment: (checked: boolean) => void;
  onToggleFrequencyMeasurement: (checked: boolean) => void;
  onToggleDurationMeasurement: (checked: boolean) => void;
  onToggleVariantCheck: (checked: boolean) => void;
  className?: string;
}

export function SurveySettingsCard({
  enableRatingAndComment,
  enableFrequencyMeasurement,
  enableDurationMeasurement,
  enableVariantCheck,
  onToggleRatingAndComment,
  onToggleFrequencyMeasurement,
  onToggleDurationMeasurement,
  onToggleVariantCheck,
  className
}: SurveySettingsCardProps) {
  const { t } = useTranslation();

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <ClipboardList className="w-5 h-5 text-muted-foreground" />
          {t('OrgSettingPage.surveySettingsTitle')}
        </CardTitle>
        <CardDescription>{t('OrgSettingPage.surveySettingsDesc')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Individual Survey Toggles */}
        <ItemGroup>
          <Item>
            <ItemContent>
              <ItemTitle className="text-base">{t('OrgSettingPage.RatingAndComment')}</ItemTitle>
            </ItemContent>
            <ItemActions>
              <Switch checked={enableRatingAndComment} onCheckedChange={onToggleRatingAndComment} />
            </ItemActions>
          </Item>

          <Item>
            <ItemContent>
              <ItemTitle className="text-base">
                {t('OrgSettingPage.FrequencyMeasurement')}
              </ItemTitle>
            </ItemContent>
            <ItemActions>
              <Switch
                checked={enableFrequencyMeasurement}
                onCheckedChange={onToggleFrequencyMeasurement}
              />
            </ItemActions>
          </Item>

          <Item>
            <ItemContent>
              <ItemTitle className="text-base">{t('OrgSettingPage.DurationMeasurement')}</ItemTitle>
            </ItemContent>
            <ItemActions>
              <Switch
                checked={enableDurationMeasurement}
                onCheckedChange={onToggleDurationMeasurement}
              />
            </ItemActions>
          </Item>

          <Item>
            <ItemContent>
              <ItemTitle className="text-base">{t('OrgSettingPage.VariantCheck')}</ItemTitle>
            </ItemContent>
            <ItemActions>
              <Switch checked={enableVariantCheck} onCheckedChange={onToggleVariantCheck} />
            </ItemActions>
          </Item>
        </ItemGroup>
      </CardContent>
    </Card>
  );
}
